
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealer/[...section]",
      function () {
        return require("private-next-pages/dealer/[...section].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealer/[...section]"])
      });
    }
  